import styled from 'styled-components';
import { Row } from '../../grid';
import { White } from '../../../colors';
import { SCREEN_SIZE } from '../../grid/constants/sizes';
export const RowContent = styled(Row) `
    align-content: center;
    height: calc(100vh - 90px);

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: auto;
    }
`;
export const RowHeader = styled(Row) `
    background-color: ${White.normal};
    height: 90px;
    z-index: 1000;

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: 64px;
    }
`;
export const ChildrenContainer = styled('div') `
    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        margin: 0 -15px;
    }
`;
export const BackgroundHeader = styled('div') `
    width: 100%;
    height: 90px;
    background-color: ${White.normal};

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: 64px;
    }
`;
//# sourceMappingURL=ApplicantLayout.Styled.js.map